__turbopack_context__.v({
  "recommended__products": "empty-basket-content-module-scss-module__hKHIgq__recommended__products",
  "root": "empty-basket-content-module-scss-module__hKHIgq__root",
  "subtitle": "empty-basket-content-module-scss-module__hKHIgq__subtitle",
  "title": "empty-basket-content-module-scss-module__hKHIgq__title",
});
